var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdownContainer"},[_c('markdown-it-vue',{attrs:{"content":_vm.resultFormula}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }